import React from "react";
import {
  CardContainer,
  TitleContainer,
  LogoCard,
} from "./CardsStyles.styled.js";
import FormatAlignLeftIcon from "@material-ui/icons/FormatAlignLeft";
import { ReactComponent as LogoIcon } from "../../assets/svg/logo-icon.svg";
import { ReactComponent as FooterIcon } from "../../assets/svg/footer-icon.svg";
import { ReactComponent as FontsIcon } from "../../assets/svg/fonts-icon.svg";
import { ReactComponent as BackgroundIcon } from "../../assets/svg/background-icon.svg";
import { ReactComponent as SaveIcon } from "../../assets/svg/save-icon.svg";
import { ReactComponent as AlignmentIcon } from "../../assets/svg/alignment-icon.svg";

const CardsStyles = ({ menu, setselectMenu }) => {
  let handleIcon = () => {
    switch (menu) {
      case "logo":
        return <LogoIcon />;
      case "footer":
        return <FooterIcon />;
      case "fonts":
        return <FontsIcon />;
      case "alignment":
        return <FormatAlignLeftIcon />;
      case "background":
        return <BackgroundIcon />;
      case "Save Survey Button":
        return <SaveIcon />;
      case "infoBanner":
        return <AlignmentIcon />;
      default:
        break;
    }
  };
  return (
    <div>
      <CardContainer
        onClick={() => setselectMenu(menu)}
        className="container-Cards"
      >
        <LogoCard>{handleIcon()}</LogoCard>
        <TitleContainer>
          <span>{`${menu.charAt(0).toUpperCase()}${menu.slice(1)}`}</span>
        </TitleContainer>
      </CardContainer>
    </div>
  );
};

export default CardsStyles;
